export type InternalAction =
  | 'list_accounts'
  | 'get_account'
  | 'create_account'
  | 'list_account_users'
  | 'update_account_user'
  | 'remove_account_user'
  | 'list_assumed_roles'
  | 'assume_role'
  | 'end_assumed_role'
  | 'get_audit_log'
  | 'deactivate_account'
  | 'manage_entitlements';

const INTERNAL_PERMISSIONS: Record<string, Set<InternalAction>> = {
  support: new Set([
    'list_accounts',
    'get_account',
    'list_account_users',
    'create_account',
    'update_account_user',
    'remove_account_user',
    'list_assumed_roles',
    'assume_role',
    'end_assumed_role',
    'get_audit_log',
    'deactivate_account',
    'manage_entitlements',
  ]),
  onboarding: new Set([
    'list_accounts',
    'get_account',
    'list_account_users',
    'create_account',
    'update_account_user',
    'remove_account_user',
    'list_assumed_roles',
    'assume_role',
    'end_assumed_role',
    'deactivate_account',
    'manage_entitlements',
  ]),
  engineering: new Set([
    'list_accounts',
    'get_account',
    'list_account_users',
    'list_assumed_roles',
    'assume_role',
    'end_assumed_role',
    'get_audit_log',
    'deactivate_account',
  ]),
  billing: new Set(['list_accounts', 'get_account', 'get_audit_log']),
};

export const canPerform = (
  role: string | undefined | null,
  action: InternalAction,
): boolean => {
  if (!role) return false;
  return INTERNAL_PERMISSIONS[role]?.has(action) ?? false;
};

export const MAX_CONCURRENT_ASSUMED_ROLES = 5;
export const ASSUMED_ROLE_MAX_DURATION_HOURS = 4;

/** Which assumed_role each internal_role is allowed to request. Mirrors backend. */
export const ALLOWED_ASSUMED_ROLES: Record<string, string[]> = {
  support: ['viewer', 'creator', 'account-admin'],
  onboarding: ['viewer', 'creator', 'account-admin'],
  engineering: ['viewer', 'creator', 'account-admin'],
  billing: [],
};
